import { http } from './http'

export const getPortalConfiguration = (forceProduction) => {
  return http().get(`/api/settings?force_production=${forceProduction}`)
}
